import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import _ from 'lodash';
import { STORAGE } from '../data/storage';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Storage } from '../models/storage';
import { FIND_SYSTEM_RULES } from '../data/storage';
import { SYSTEM } from '../data/system';
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storageSource = new BehaviorSubject(_.cloneDeep(STORAGE));
  storage$ = this.storageSource.asObservable();

  get storage(): Storage {
    return this.storageSource.value;
  }

  set storage(storage: Storage) {
    this.storageSource.next(storage);
  }


  clearStorage() {
    this.storage = _.cloneDeep(STORAGE);
  }

  getSystemIndexById(id): number {
    let index = null;
    if (id !== undefined && id !== null) {
      for (let i = 0; SYSTEM.length; i++) {
        if (SYSTEM[i].id === id) {
          index = i;
          break;
        }
      }
    }
    return index;
  }

  getSideName(staticName: string) {
    switch (staticName) {
      case 'INSIDE':
        return 'inside';
      case 'OUTSIDE':
        return 'outside';
    }
  }

  getTypeName(staticName: string) {
    switch (staticName) {
      case 'STANDARD':
        return 'standard';
      case 'NONSTANDARD':
        return 'nonstandard';
    }
  }

  setSystemType(type) {
    const currentStorage = this.storage;
    currentStorage.systemType = type;
    this.storage = currentStorage;
  }


  getWindowTotalLength(): number {
    let totalLength = 0;
    for (const wind of this.storage.windows) {
      let w = null;
      if (wind.type !== undefined && wind.type !== null) {
        w = wind[wind.type.toLowerCase()];
        const windowInsideLength = this.sumEdgesLength(w.inside.edges);
        const windowOutsudeLength = this.sumEdgesLength(w.outside.edges);
        totalLength += ((windowInsideLength + windowOutsudeLength) / 2) * wind.amount;

      }
    }
    // console.warn(totalLength);
    // console.log(this.storage)
    return totalLength;
  }

  private sumEdgesLength(edges) {
    let length = 0;
    for (const edge of edges) {
      length += edge.length;
    }

    return length;
  }
}
